import { DataKeySet } from './data-key-set.js'
import { DataKeySetQuery } from './data-key-set-query.js'
import { DataKeySetMutation } from './data-key-set-mutation.js'

export const entities = [DataKeySet]
export const resolvers = [DataKeySetQuery, DataKeySetMutation]
